/** Pick readable title/blurb colors for lesson card backgrounds (solid hex or gradient). */
export function textColorsForBackground(background: string): { title: string; blurb: string; tone: "light" | "dark" } {
  const sample = background.startsWith("linear-gradient")
    ? background.match(/#[0-9a-fA-F]{3,8}/)?.[0]
    : background;

  const rgb = sample ? parseHex(sample) : null;
  if (!rgb) {
    return { title: "#fdf9f3", blurb: "rgba(253, 249, 243, 0.88)", tone: "dark" };
  }

  const lum = relativeLuminance(rgb.r, rgb.g, rgb.b);
  if (lum > 0.48) {
    return { title: "#1a1a1b", blurb: "rgba(26, 26, 27, 0.82)", tone: "light" };
  }
  return { title: "#fdf9f3", blurb: "rgba(253, 249, 243, 0.88)", tone: "dark" };
}

function parseHex(color: string): { r: number; g: number; b: number } | null {
  const hex = color.trim().replace("#", "");
  if (hex.length === 3) {
    return {
      r: parseInt(hex[0]! + hex[0]!, 16),
      g: parseInt(hex[1]! + hex[1]!, 16),
      b: parseInt(hex[2]! + hex[2]!, 16),
    };
  }
  if (hex.length === 6) {
    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16),
    };
  }
  return null;
}

function relativeLuminance(r: number, g: number, b: number): number {
  const linear = [r, g, b].map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * linear[0]! + 0.7152 * linear[1]! + 0.0722 * linear[2]!;
}
